/* eslint-disable react/destructuring-assignment */

import React, { Component } from 'react';
import { EmailTemplateViewModel, ClientViewModel } from 'stageclip-common';

import { ModalContainer } from '../guardedModal/ModalContainer';

import { fetchSurveyTemplate, updateClient } from 'api/clients/clients.actions';
import AppModal from 'components/modal/appModal';
import { PreviewTemplate } from './previewTemplate/previewTemplate';

type SurveyTemplateModalContentState = {
  data: EmailTemplateViewModel | null;
  error: boolean;
};

export class SurveyTemplateModalContent extends Component<any, SurveyTemplateModalContentState> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: null,
      error: null,
    };
  }

  componentDidMount(): void {
    const { dispatch, clientId } = this.props;

    dispatch(fetchSurveyTemplate(clientId))
      .then(({ payload }: { payload: EmailTemplateViewModel }) => this.setState({ data: payload }))
      .catch(() => this.setState({ error: true }));
  }

  markAsRead = () => {
    const { dispatch, clientId, onClose } = this.props;

    dispatch(updateClient(clientId, { surveyUpdated: false }))
      .then(({ payload }: { payload: ClientViewModel }) => {
        onClose(payload);
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  };

  render() {
    const { data, error } = this.state;
    const { id } = this.props;

    return (
      // @ts-ignore
      <AppModal
        id={id}
        title="Survey template"
        hideOpenButton
        closeButtonLabel="Mark as read"
        onClose={this.markAsRead}
      >
        {!!error && <div>Survey template is not created</div>}
        {!error && (!!data || <div>loading</div>)}
        {!error && !!data && <PreviewTemplate initialValues={data} form={id} />}
      </AppModal>
    );
  }
}

type SurveyTemplateModalProps = { onClose: (payload: any) => void };

export const SurveyTemplateModal = (props: SurveyTemplateModalProps) => {
  const { onClose } = props;

  return (
    <ModalContainer id="survey-template-modal">
      <SurveyTemplateModalContent onClose={onClose} />
    </ModalContainer>
  );
};
